module.exports = "<p>\r\n  lift-board-parameter-detail works!\r\n</p>\r\n"